var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.799805 3.59998H2.0998H12.4998",
    stroke: "#24A95D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04961 3.6V2.3C4.04961 1.95522 4.18657 1.62456 4.43037 1.38076C4.67417 1.13696 5.00483 1 5.34961 1H7.94961C8.29439 1 8.62505 1.13696 8.86885 1.38076C9.11265 1.62456 9.24961 1.95522 9.24961 2.3V3.6M11.1996 3.6V12.7C11.1996 13.0448 11.0626 13.3754 10.8188 13.6192C10.5751 13.863 10.2444 14 9.89961 14H3.39961C3.05483 14 2.72417 13.863 2.48037 13.6192C2.23657 13.3754 2.09961 13.0448 2.09961 12.7V3.6H11.1996Z",
    stroke: "#24A95D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinGroup);
export default __webpack_public_path__ + "static/media/binGroup.ab78090040e8f7ee9b833458724f3904.svg";
export { ForwardRef as ReactComponent };